module.exports = __webpack_public_path__ + "img/point1.4feb6336.png";